import React from "react";
import styled from "styled-components";
import PopoverOnHover from "../elements/PopoverOnHover";
import PropTypes from "prop-types";
import InsuranceStatusConstants from "../../constants/InsuranceStatusConstants";
import NotificationTypeConstants from "../../constants/NotificationTypeConstants";
import PlayerRequestStatusConstants from "../../constants/PlayerRequestStatusConstants";

const NotificationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const NotificationTypeText = styled.div`
  font-weight: bold;
`;

const OrgFedText = styled.div`
  font-size: 0.75rem;
  margin-left: 0.5rem;
`;

const PopoverContent = styled.div`
  padding: 8px;
  min-width: 200px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  background-color: white;
`;

const PopoverRow = styled.div`
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const NotificationNameFormatter = ({ row }) => {
  if (!row.notificationName) return null;
  const notifcationType = row.notificationName.split(",")[0];
  const orgOrFed = row.notificationName.split(", ")[1];

  const getStatusString = () => {
    if (!row?.notificationTypeName || !row?.notificationStateId) return "";
    switch (row?.notificationTypeName) {
      case NotificationTypeConstants.NAMES[NotificationTypeConstants.TYPE.CHRONIC_CONDITION]:
        return InsuranceStatusConstants.DESCRIPTIONS[row.notificationStateId];
      case NotificationTypeConstants.NAMES[NotificationTypeConstants.TYPE.REQUEST]:
        return PlayerRequestStatusConstants.DISPLAY_NAMES[row.notificationStateId];
      default:
        return "";
    }
  };

  const notificationContent = (
    <NotificationContainer className="d-flex flex-row align-items-center">
      <NotificationTypeText>{notifcationType}</NotificationTypeText>
      <OrgFedText>({orgOrFed})</OrgFedText>
    </NotificationContainer>
  );

  const statusString = getStatusString();

  // Only show popover if there's a status string
  if (statusString) {
    const popoverContent = (
      <PopoverContent>
        <PopoverRow>
          <strong>Status:</strong> {statusString}
        </PopoverRow>
      </PopoverContent>
    );

    return (
      <PopoverOnHover content={popoverContent} position="right">
        {() => notificationContent}
      </PopoverOnHover>
    );
  }

  // No popover if no status string
  return notificationContent;
};

NotificationNameFormatter.propTypes = {
  row: PropTypes.shape({
    notificationName: PropTypes.string.isRequired,
    notificationTypeName: PropTypes.string,
    notificationStateId: PropTypes.number
  }).isRequired
};

export default NotificationNameFormatter;
